export default {
  frontImage: 'Front image',
  backImage: 'back image',
  healthCare: 'health care',
  driverFleetSmartCard: 'Driver fleet smart card',
  navyFleetSmartCard: 'Navy fleet smart card',
  certificate: 'certificate',
  vehicleIdentificationCard: 'vehicle identification card',
  nationalCard: 'national card',
  cardNumber: 'Card number',
  approvedSuccessfully: 'Approved successfully'
}
